/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {UpdateUnitBrandDataRequest} from '@cash-web/protos/squareup/roster/mds.pb'
import {UpdateUnitBrandDataResponse} from '@cash-web/protos/squareup/roster/mds.pb'


export const updateUnitBrandData = (request: UpdateUnitBrandDataRequest, options?: CashRequestOptions) => post<UpdateUnitBrandDataRequest, UpdateUnitBrandDataResponse>("/2.0/cash/update-unit-brand-data", request, {...options, rejectOnError: true })